import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "../../axios-backend";
import Line from "../main/Line";
import Button from "../main/Button";
import BackButton from "../main/BackButton";
import Columns from "../main/Columns";

const Sizes = (props) => {
  const navigate = useNavigate();
  const [sizes, setSizes] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    axios.get("/sizes").then((s) => {
      setSizes(s.data.list);
      console.log("Fetched sizes:", s.data.list);
      console.log(s);
    });
  };

  const handleRedirect = () => {
    navigate("/edit-size");
  };

  const handleDelete = (id, typeId) => {
    const payload = { id: Number(id), typeId: Number(typeId) };
    console.log("Attempting to delete with payload:", payload);
    const result = window.confirm("Are you sure you want to delete this size?");
    if (result) {
      axios.delete("/sizes", { data: payload }).then((res) => {
        console.log("Delete response:", res);
        getData();
      });
    }
  };

  const renderTypes = () => {
    if (sizes.length > 0) {
      return sizes.map((s) => {
        return (
          <Line type="bottom-line" key={s.id}>
            <Columns width="20%">{s.name}</Columns>
            <Columns width="20%">{s.typeName}</Columns>
            <Columns width="20%">
              {s.gender === "0"
                ? "female"
                : s.gender === "1"
                  ? "male"
                  : "unisex"}
            </Columns>
            <Columns width="40%">
              <Link
                to={`/edit-size?id=${s.id}`}
                style={{ marginRight: "1rem" }}
              >
                <Button>Update</Button>
              </Link>
              <Link
                to={`/view-size-guides?id=${s.id}`}
                style={{ marginRight: "1rem" }}
              >
                <Button>Size guides</Button>
              </Link>
              <Button onClick={() => handleDelete(s.id, s.typeId)}>Delete</Button>
            </Columns>
          </Line>
        );
      });
    } else
      return (
        <Line type="bottom-line" style={{ justifyContent: "center" }}>
          loading...
        </Line>
      );
  };

  return (
    <div style={{ height: "100%" }}>
      <BackButton />
      <Line type="bottom-line">
        <Columns width="20%">size name</Columns>
        <Columns width="20%">belongs to</Columns>
        <Columns width="20%">gender</Columns>
        <Columns width="40%">
          <Button onClick={handleRedirect}>Add new size</Button>
        </Columns>
      </Line>
      {renderTypes()}
    </div>
  );
};

export default Sizes;
